import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import MainTopBar from '@/components/common/bar/MainTopBar'
import Toast from '@/components/common/toast/ToastMessage'
import { useGetConsultationList, useGetMyStepsByLatestBlock } from '@/hooks/queries/chat'
import { useStartNewConsultation } from '@/hooks/queries/chat/mutation'
import qbeeHappyTransparent from '@/assets/images/qbee-character/qbee-happy-transparent.png'
import { openNativeChatPage } from '@/utils/webViewBridge'

export default function RoomCheckPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const [showToast, setShowToast] = useState(false)

  const hasCallCreateApiRef = useRef(false)

  const { refetch: refetchConsultationList } = useGetConsultationList()
  const { refetch: refetchGetMyStepsByLatestBlock } = useGetMyStepsByLatestBlock()
  const { mutate: startNewConsultation, isError: isStartNewConsultationError } = useStartNewConsultation()

  // useCallback으로 함수 메모이제이션 (의존성 배열 비우기)
  const createChatRoom = () => {
    // 중복 api 호출 막기
    if (hasCallCreateApiRef.current) return

    hasCallCreateApiRef.current = true

    const message = location.state?.message || ''
    const block_id = location.state?.block_id || 0

    startNewConsultation(
      { message, block_id },
      {
        onSuccess: data => {
          // navigate(`/chat/${data.id}`, { replace: true, state: { ...location.state, initialResponse: data } })
          openNativeChatPage(Number(data.id), '/chat')
          refetchConsultationList()
          refetchGetMyStepsByLatestBlock()
        }
      }
    )
  }

  useEffect(() => {
    // 페이지 로드 시 즉시 상담 전략 생성 시작
    createChatRoom()
  }, [])

  const handleBack = () => {
    navigate('/chat', { replace: true })
  }

  return (
    <div className='flex flex-col h-screen overflow-hidden relative'>
      {/* 상단 바 */}
      <MainTopBar
        hasBackButton={true}
        handleClickBackButton={handleBack}
        leftSide={
          <div className='flex items-center w-full'>
            <h1 className='text-header-title font-semibold text-amber-900'>상담방 준비 중</h1>
          </div>
        }
      />

      {/* 메인 컨텐츠 */}
      <main className='flex-1 flex flex-col items-center justify-center px-4'>
        {isStartNewConsultationError ? (
          <div className='text-center'>
            <div className='text-red-600 mb-4 text-lg font-medium'>상담방 생성에 실패했습니다. 다시 시도해주세요.</div>
            <button
              onClick={() => window.location.reload()}
              className='px-6 py-3 bg-amber-700 text-white rounded-lg font-medium hover:bg-amber-800 transition-colors'
            >
              다시 시도
            </button>
          </div>
        ) : (
          <div className='text-center z-10 px-8'>
            <div className='bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/30'>
              <div className='flex justify-center mb-6'>
                <div className='relative'>
                  <img src={qbeeHappyTransparent} alt='큐비 캐릭터' className='w-16 h-16 animate-bounce' />

                  <div className='absolute -top-2 -right-2 text-2xl animate-pulse delay-300'>✨</div>
                </div>
              </div>

              <>
                <h1 className='text-amber-900 text-xl font-bold leading-relaxed mb-2'>곧 상담이 시작될거야!</h1>
                <p className='text-amber-800 text-base'>잠시만 기다려줘!</p>

                {/* 로딩 인디케이터 */}
                <div className='mt-6 flex justify-center'>
                  <div className='w-8 h-8 border-3 border-amber-200 border-t-amber-600 rounded-full animate-spin'></div>
                </div>
              </>
            </div>
          </div>
        )}
      </main>

      {/* 토스트 메시지 */}
      <Toast
        message='상담 전략 생성을 위해 다시 접속해주세요'
        isVisible={showToast}
        onClose={() => setShowToast(false)}
        duration={2000}
      />
    </div>
  )
}
